import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

import useEnrollmentUrl from '../../../hooks/useEnrollmentUrl';
import Button from '../../../components/button/Button';

import './getTestedSection.scss';

export default function GetTestedSection() {
  const { enrollmentUrl } = useEnrollmentUrl();

  return (
    <section id="get-tested" className="get_tested">
      <StaticImage src="../../../images/index/david.png" className="background" alt="" />

      <div className="container">
        <h2>
          A sleep study,
          <br />
          {' '}
          <span className="salmon">right from home</span>
        </h2>

        <h6>Award-winning. Clinically&nbsp;proven. No&nbsp;lab&nbsp;required.</h6>

        <p>
          The Sunrise
          <strong> home sleep test </strong>
          won the SleepTech Award 2022 for its clinical accuracy. Meet with a sleep provider,
          use the device* at home, and get the answers you need to start feeling like yourself
          again.
        </p>

        <div className="certification-container">
          <StaticImage src="../../../images/index/get_tested_certification.png" alt="certification" />
          <p>
            *We also prescribe WatchPAT devices
            {' '}
            <br />
            and coordinate in-lab testing if need be.
          </p>
        </div>

        <Button
          text="Get diagnosed"
          displayArrow
          dataAttr="CTA_clicked_get-tested"
          className="blue"
          link={enrollmentUrl}
          target="_blank"
        />
      </div>
    </section>
  );
}
